import { create } from 'zustand'

import { ModalStoreType } from './types'

export const useModalStore = create<ModalStoreType>((set) => ({
  shouldOnboardingModalOpen: false,
  setShouldOnboardingModalOpen(isOpen: boolean) {
    set({ shouldOnboardingModalOpen: isOpen })
  },
}))
